<nav class="nav fixed-top p-3 justify-content-center"
style="background-image: url('assets/img/h1_hero.png');
              background-repeat: no-repeat;
                background-attachment: fixed;
      background-position: center; 
       background-size: cover;
            "
            >
    <a class="nav-link" routerLink="/">Home</a>
    <a class="nav-link" routerLink="/aplikasi">Applikasi</a>
    <a class="nav-link" routerLink="/website">Website</a>
    <a class="nav-link" routerLink="/axcoraschool">ERP</a>
  </nav>

<div class="container">
<div class="row">
    <div class="col-12 col-md-12 p-3 p-md-5 text-center">
        <img src="assets/img/logo.png" alt="aplikasi Rapot Online"/><br/>    
    <img class="img-fluid rounded shadow" src="assets/img/aplikasi elearning online simple belajar mengajar sekolah (7).png" alt="aplikasi belajar sekolah simple"/><br/>
    <h3 class="text-left"><strong><a href="https://axcoraschool.vercel.app">Aplikasi E-Learn Simple</a></strong></h3>
<p class="text-left">Aplikasi sekolah untuk kebutuhan belajar mengajar dengan simple system dan lengkap dengan laporan dalam kebutuhan nya. Lengkap dengan fitur data siswa , ujian, dan laporan nilai , secara skema kami mendevelope nya untuk kebutuhan per kelas agar memudahkan masing masing kelas untuk menggunakan applikasi belajar mengajar dengan simple system include dengan penilaian secara langsung dalam penerapan nya, aplikasi e-learn simple ini, memudahkan untuk aktivitas sekolah, dengan guru bertugas dalam mempersiapkan materi soal dan ujian include dengan pilihan jawaban soal , selanjutnya siswa akan memiliki login sendiri yang bertugas untuk cek tugas dan ujian yang diberikan guru secara online.</p>
 
<img class="img-fluid rounded shadow" src="assets/img/aplikasi elearning online simple belajar mengajar sekolah (12).png" alt="aplikasi belajar online sekolah"/><br/>
<p class="text-left">Dengan dukungan full web app installasi memudahkan murid dan guru penilai untuk akses apps ini via smartphone android iphone pc desktop laptop windows dan multi device OS lain nya, semakin memudahkan dalam berbagai proses untuk menjawab dan memberikan materi soal tugas dan ujian secara real time online.</p>
<img class="img-fluid shadow rounded" src="assets/img/aplikasi elearning online simple belajar mengajar sekolah (14).png" alt="aplikasi belajar sekolah online gratis website"/><br/>
<p class="text-left">
Hadir laporan laporan detail memudahkan dalam setiap kebutuhan untuk cek tugas dan ujian siswa, penilaian secara langsung mempercepat dalam proses belajar mengajar, include dengan status tugas misalnya sudah dikerjakan hingga belum dikerjakan. anda dapat order apps ini include dengan website atau plugin tambahan order untuk website sekolah axcora school cms anda.
    <a href="https://www.youtube.com/watch?v=tq4DuRHo8zY" target="_blank" class="text-danger">cek demo nya disini →</a>
</p>
<div class="row">
    <div class="col-6 col-md-6 p-3 p-md-5">
        <div class="border border-dark p-3 rounded">
<h3 class="bg-dark text-white p-3 text-center">Plugin website</h3>
<p>Plugin untuk paket website axcora school cms.</p>
<p class="border border-dark p-3 text-center"><strong>Rp.568.400</strong></p>
    </div></div>
    <div class="col-6 col-md-6 p-3 p-md-5">
        <div class="border border-danger p-3 rounded">
<h3 class="bg-danger text-white p-3 text-center">E-Learn Simple</h3>
<p>
    E-learn Simple Apps
, Free Domain .sch.id
, Web Space 1.5GB
, Include Host
, <a routerLink="/cms" class="text-danger">axcora school cms →</a>
, website sekolah
, APK Android Guru
, APK Android Siswa 
</p>
<p class="border border-danger p-3 text-center"><strong>Rp.2.512.300</strong></p>
<div class="text-center">
    <a href="https://wa.me/6285646104747?text=Axcoraschoolapps%20saya%20mau%20order%20Website%0ANama/Sekolah%20%3A%0AAlamat%20%3A%0APaketweb%20%3AAxcoraschoolcms+E-learnsimple%0APrice%20%3ARp.2.512.300/tahun%0APembayaran%20via%20%3A%0ABCA%208290363021%20Rica%20Anggraini%0A%0Atolong%20diproses%20pesanan%20saya" class="btn card-btn1">Order</a>
</div>
    </div></div>
</div>
<a routerLink="/website" class="btn btn-success rounded-pill btn-lg">Cek Paket website</a>
</div>


    </div></div>

  
    <div class="testimonial-area fix" >

    
    
        <div class="wantToWork-area ">
        <div class="container">
        <div class="wants-wrapper w-padding2 section-bg2" 
         style="background-image: url('assets/img/section_bg02.png');
                  background-repeat: no-repeat;
                    background-attachment: fixed;
          background-position: center; 
           background-size: cover;
                "
                >
        <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-9 col-md-8">
        <div class="wantToWork-caption text-center">
        <h2>ERP Sekolah</h2>
        <p>All in one system web app sekolah dalam satu applikasi super lengkap dalam kebutuhan proses belajar mengajar , e learning, absensi, hingga keuangan sekolah , agenda pengumuman berita sekolah include.
    <br/>
    Applikasi ERP sekolah dengan admin apps, guru pengajar apps, tata usaha dan keuangan apps, siswa murid apps, all in one integrasi dalam axcora school ERP untuk sekolah anda.
        </p>
        <a routerLink="/axcoraschool" class="btn3 wantToWork-btn">Pelajari ERP Sekolah</a><br/><br/><br/><br/>
        </div>
        </div>
        </div>
        </div>
        </div>
        </div>
        
      </div>
